import { useOffers } from "@nju/data-access-portal-offers";
import { PostpaidOfferDetails } from "@nju/feature-portal-offers";
import { Icon } from "@nju/icons";
import {
  A,
  BlockText,
  Drawer,
  Heading,
  Panel,
  Separator,
  Text,
  useOverlay,
} from "@nju/ui";

export function PostpaidBanner() {
  const drawer = useOverlay();
  const { postpaid } = useOffers();
  const { indefiniteOffers } = postpaid;
  const offer = indefiniteOffers.find((offer) => {
    return offer.display;
  });

  return (
    <>
      {drawer.isOpened && offer && (
        <Drawer onClose={drawer.close}>
          <PostpaidOfferDetails offer={offer} />
        </Drawer>
      )}
      <Panel
        badge={[
          {
            iconName: "star-filled",
            body: "Bestseller",
            variant: "cerulean",
          },
          {
            body: "5G",
            variant: "dark",
          },
        ]}
        forceShowTitleBlock={true}
        invisibleSeparator={true}
        separatorSize="none"
        testId="postpaid-offer-banner"
      >
        <Icon
          className="mr-3 w-6 h-6 from-tablet:w-8 from-tablet:h-8"
          name="mobile-android"
          tone="accent"
        />
        <Separator
          size={{
            "@onlyMobile": "s",
            "@fromDesktop": "xs",
          }}
          tone="invisible"
        />
        <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
          nju abonament
        </Heading>
        {offer && (
          <BlockText className="mt-1" size="l">
            od {offer.totalRecurringPrice} zł/mies.
          </BlockText>
        )}
        <Separator size="m" tone="invisible" />
        <A
          className="items-center gap-3"
          display="inlineFlex"
          onClick={drawer.open}
          size="inline"
          variant="simple"
        >
          <Text tone="accent">sprawdź</Text>
          <Icon height={18} name="arrow-right" tone="accent" width={18} />
        </A>
      </Panel>
    </>
  );
}
